import React, { useEffect, useState } from 'react';
import LitStructuredText from './generic/LitStructuredText';
import LitImage from './images/LitImage';
import SpeedAnimationProgressBar from './SpeedAnimationProgressBar';

const SpeedAnimation = ({
  image,
  speedAnimationText,
  speedAnimationContent,
  caveatText,
}) => {
  return (
    <>
      <div className="speed-animation-container modular-p modular-heading-secondary Black">
        <div className="speed-image">
          <LitImage image={image} />
        </div>
        <LitStructuredText data={speedAnimationText} basic />
        {speedAnimationContent.map(
          (
            { speedAnimationNumber, speedBarColour, speedLink, speedTitle },
            index,
          ) => {
            return (
              <SpeedAnimationProgressBar
                speedAnimationNumber={speedAnimationNumber}
                speedBarColour={speedBarColour}
                speedLink={speedLink}
                speedTitle={speedTitle}
                key={index}
              />
            );
          },
        )}
        <div className="content-caveat-text modular-p">
          <LitStructuredText data={caveatText} />
        </div>
      </div>
    </>
  );
};

export default SpeedAnimation;
